import { PreavisInterventionDTO } from '@/models/PreavisIntervention/PreavisInterventionDTO';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { EquipementItems } from '@/models/EquipementItems';
import { Site } from '@/models/Site';

export interface CreateDirectPayload {
    equipement: EquipementItems;
    // siteId: number;
    initialStep: number;
}

export interface PreavisInterventionState {
    isModaleOpen: boolean;
    isLoadingList: boolean;
    isSubmitting: boolean;
    error?: string | null;
    items: PreavisInterventionDTO[];
    tableHeader: TableHeader[];
    selectedItemId?: number | null;
    currentSiteId?: number;
    currentEquipementId?: number;
    createDirect: CreateDirectPayload | null;
    preavisSite?: Site;
}

export function getInitialState(): PreavisInterventionState {
    return {
        isModaleOpen: false,
        isLoadingList: false,
        isSubmitting: false,
        error: null,
        items: [],
        tableHeader: [
            {
                label: 'preavisIntervention.objet.libelle',
                sortStatus: SortType.NONE,
                sortData: 'objet',
            },
            {
                label: 'preavisIntervention.site',
                sortStatus: SortType.INACTIVE,
                sortData: 'site.libelle',
            },
            {
                label: 'preavisIntervention.materiel',
                sortStatus: SortType.INACTIVE,
                sortData: 'equipement.libelle',
            },
            {
                label: 'preavisIntervention.delai',
                sortStatus: SortType.NONE,
                textalign: 'center',
                sortData: 'delai',
                regleCle: 'preavisIntervention.delaiMax',
            },
            {
                label: 'preavisIntervention.emailsAlerte',
                sortStatus: SortType.INACTIVE,
                sortData: 'emails',
                regleCle: 'preavisIntervention.emailsRegles',
            },
            {
                label: 'preavisIntervention.actif',
                sortStatus: SortType.NONE,
                sortData: 'actif',
            },
            {
                label: 'preavisIntervention.actions',
                sortStatus: SortType.INACTIVE,
                sortData: 'actions',
            },
        ],
        selectedItemId: null,
        currentSiteId: undefined,
        currentEquipementId: undefined,
        createDirect: null,
        preavisSite: undefined,
    };
}

export const state: PreavisInterventionState = getInitialState();
